export default {"src":"/_next/static/media/HalfStarIconNew.0a72e09e.svg","height":15,"width":15};